import React, { useMemo } from 'react';
import { useTable } from "react-table";
import "./gameLog.css";

export const GameLog = () => {

    const columns = useMemo(() => [
        {
            Header: "CC",
            accessor: "cc"
        },
        {
            Header: "Time GMT",
            accessor: "time"
        },
        {
            Header: "Game Time",
            accessor: "gameTime"
        },
        {
            Header: "Trade",
            accessor: "trade"
        },
        {
            Header: "Price",
            accessor: "price"
        },
        {
            Header: "Quantity",
            accessor: "quantity"
        },
        {
            Header: "Total",
            accessor: "total"
        },
        {
            Header: "Demo AC",
            accessor: "demoAc",
        },
    ])

    const data = [
        {
            cc: "01/12/21",
            time: "13:35:00",
            gameTime: "13:35:00",
            trade: "(10.0)",
            price: "200.00",
            quantity: "200.00",
            total: "200.00",
            demoAc: "200.00",
        },
    ]

    return (
        <main className='game_log-main'>
            <h2>Demo Game Log & Sales Journal</h2>
            <Table columns={columns} data={data} />
        </main>
    )
}


export const Table = ({ columns, data }) => {
    const {
        getTableProps,
        getTableBodyProps, // table body props from react-table
        headerGroups, // headerGroups, if your table has groupings
        rows, // rows for the table based on the data passed
        prepareRow // Prepare the row (this function needs to be called for each row before getting the row props)
    } = useTable({
        columns,
        data
    });

    /* 
      Render the UI for your table
      - react-table doesn't have UI, it's headless. We just need to put the react-table props from the Hooks, and it will do its magic automatically
    */
    return (
        <table className='game_log-table' {...getTableProps()}>
            <thead className='game_log-table-head demo-head'>
                {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map(column => (
                            <th {...column.getHeaderProps()}>{column.render("Header")}</th>
                        ))}
                    </tr>
                ))}
            </thead>
            <tbody className='reactTable-body demo-body' {...getTableBodyProps()}>
                {rows.map((row, i) => {
                    prepareRow(row);
                    return (
                        <tr {...row.getRowProps()}>
                            {row.cells.map(cell => {
                                return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
                            })}
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
}
